var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 20,
    height: 20,
    transform: "translate(31 74)",
    fill: "#dc313a",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_57",
    "data-name": "Mask Group 57",
    transform: "translate(-31 -74)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(28.692 71.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M7.692,6.923H21.538",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.538
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M7.692,12.308H21.538",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.538
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M7.692,17.692H21.538",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.538
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 0.769,
    cy: 0.769,
    r: 0.769,
    transform: "translate(3.077 6.154)",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.538
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 0.769,
    cy: 0.769,
    r: 0.769,
    transform: "translate(3.077 11.538)",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.538
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 0.769,
    cy: 0.769,
    r: 0.769,
    transform: "translate(3.077 16.923)",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.538
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsGray);
export default __webpack_public_path__ + "static/media/reports-gray.8cf0385fbc7f7349bfe4b6f2e255819d.svg";
export { ForwardRef as ReactComponent };